function _tagged_template_literal(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _tagged_template_literal([
        "\n  mutation UpdateTextSetting($enabled: Boolean!) {\n    updateTextSetting(enabled: $enabled) {\n      success\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _tagged_template_literal([
        "\n  mutation UpdateEmail($email: String!, $password: String!) {\n    updateEmail(email: $email, password: $password) {\n      success\n    }\n  }\n"
    ]);
    _templateObject1 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _tagged_template_literal([
        "\n  mutation UpdateEmailV2($email: String!) {\n    updateEmailV2(email: $email) {\n      success\n    }\n  }\n"
    ]);
    _templateObject2 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _tagged_template_literal([
        "\n  mutation UpdateProfile($profile: consumerUserProfileInput!) {\n    updateProfileV2(profile: $profile) {\n      success\n    }\n  }\n"
    ]);
    _templateObject3 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _tagged_template_literal([
        "\n  mutation UpdateConsumerUser($input: consumerUserProfileInput!) {\n    updateConsumerUser(user: $input) {\n      success\n    }\n  }\n"
    ]);
    _templateObject4 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _tagged_template_literal([
        "\n  mutation SendVerificationToken($redirectUrl: String!, $dispensaryId: String) {\n    sendVerificationToken(redirectUrl: $redirectUrl, dispensaryId: $dispensaryId) {\n      success\n    }\n  }\n"
    ]);
    _templateObject5 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = _tagged_template_literal([
        "\n  mutation ValidateVerificationToken($token: String!) {\n    validateVerificationToken(token: $token) {\n      success\n    }\n  }\n"
    ]);
    _templateObject6 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = _tagged_template_literal([
        "\n  mutation AcceptTermsOfService {\n    acceptTermsOfService {\n      success\n    }\n  }\n"
    ]);
    _templateObject7 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = _tagged_template_literal([
        "\n  mutation SetViewedTermsOfService {\n    setViewedTermsOfService {\n      success\n    }\n  }\n"
    ]);
    _templateObject8 = function _templateObject() {
        return data;
    };
    return data;
}
import gql from 'graphql-tag';
export var updateTextSetting = gql(_templateObject());
export var updateEmailMutation = gql(_templateObject1());
export var updateEmailV2Mutation = gql(_templateObject2());
export var updateProfile = gql(_templateObject3());
export var updateConsumerUser = gql(_templateObject4());
export var sendVerificationTokenMutation = gql(_templateObject5());
export var validateVerificationTokenMutation = gql(_templateObject6());
export var acceptTermsOfService = gql(_templateObject7());
export var setViewedTermsOfService = gql(_templateObject8());
